import { Content as PopoverContent } from '@radix-ui/react-popover'
import React from 'react'

import { css } from 'design'
import { cn } from 'util/cn'

// Export unstyled items
export { Root, Trigger, Anchor } from '@radix-ui/react-popover'

const popoverStyles = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  fontSize: '$3',
  color: '$grey700',
  borderRadius: '$2',
  position: 'relative',
  zIndex: 10,
  backgroundColor: '$backgroundSecondary',
  border: '1px solid $grey200',
  boxShadow: '$2',

  '> * + *': {
    borderTop: '1px solid $grey100',
  },
})

export const Content = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof PopoverContent>
>(({ className, children, ...props }, ref) => {
  return (
    <PopoverContent
      className={cn(
        className,
        popoverStyles(),
      )}
      {...props}
      ref={ref}
    >
      {children}
    </PopoverContent>
  )
})

Content.displayName = 'Content'
